// TEA delivers the confidential longitudinal summary reports as xlsx workbooks beginning
// with the Class of 2025 (2026 accountability). Validates the title block and extracts the
// class year plus report length (FOUR/FIVE/SIX) so the dynamic FYLI/F5YLI/SYLI type can be built.

// cell.text throws on merged cells whose master value is null (TEA's title block has those),
// so derive text from cell.value instead.
const cellText = (cell) => {
  const value = cell ? cell.value : null;
  if (value == null) {
    return '';
  }
  if (typeof value === 'object') {
    if (Array.isArray(value.richText)) {
      return value.richText.map((part) => part.text).join('');
    }
    if (value.text != null) {
      return String(value.text);
    }
    return '';
  }
  return String(value);
};

const isXlsxGradData = (file) =>
  new Promise((resolve) => {
    const isXlsxFile =
      file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
      (file.name || '').toLowerCase().endsWith('.xlsx');
    if (!isXlsxFile) {
      resolve({ isValid: false });
      return;
    }
    const reader = new FileReader();
    reader.onerror = () => resolve({ isValid: false });
    reader.onload = async () => {
      try {
        const exceljsModule = await import('exceljs/dist/exceljs.min.js');
        const ExcelJS = exceljsModule.default || exceljsModule;
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(reader.result);
        const sheet = workbook.worksheets[0];
        const titleBlock = [];
        for (let rowNumber = 1; rowNumber <= 8; rowNumber += 1) {
          titleBlock.push(cellText(sheet.getCell(`A${rowNumber}`)).trim());
        }
        const isConfidential = titleBlock.some((line) => /^C O N F I D E N T I A L$/.test(line));
        const hasDistrictNumber = titleBlock.some((line) => /^District No\.: \d{6}$/.test(line));
        const titleMatch = titleBlock
          .map((line) => /^CLASS OF (\d{4}) (FOUR|FIVE|SIX)-YEAR (?:EXTENDED )?LONGITUDINAL SUMMARY REPORT$/.exec(line))
          .find(Boolean);
        if (isConfidential && hasDistrictNumber && titleMatch) {
          resolve({ isValid: true, assessmentYear: titleMatch[1], reportLength: titleMatch[2] });
          return;
        }
        resolve({ isValid: false });
      } catch (error) {
        resolve({ isValid: false });
      }
    };
    reader.readAsArrayBuffer(file);
  });

export default isXlsxGradData;
